import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-noche" data-id="element-170" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-171" data-mp="3b146nhllnt7f">
        <h2 id="testimonios" className="font-display text-[1.75rem] uppercase leading-[1.08] tracking-wide text-white sm:text-5xl" data-id="element-172" data-mp="3ayqb77n0cezc">
          Lo que dicen{' '}
          <span className="text-oro" data-id="element-173" data-mp="321z665qh9psm">quienes ya empezaron</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-174" data-mp="2x1bi9sxjpp2m">
          De no comprender las fórmulas a entender cómo resolver ejercicios de
          química.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-175" data-mp="v8555k5bgowg">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-xl border-2 border-ciencia bg-white p-2.5 text-left text-noche ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-176" data-mp="qbn3wu9738ov" data-mpi={i}>
              <div className="flex items-start justify-between gap-2" data-id="element-177" data-mp="79v83d9i1mis">
                <span className="font-sub text-[11px] font-extrabold leading-tight text-noche" data-id="element-178" data-mp="c7myg2uhx0kv">
                  {t.label}
                </span>
                <div className="flex flex-shrink-0 gap-0.5" aria-label="5 de 5 estrellas" data-id="element-179" data-mp="14vj1rqeklqqm">
                  {Array.from({
                length: 5
              }).map((_, j) => <StarIcon key={j} size={13} className="fill-oro text-oro-dark" data-id="element-180" data-mp="q63fonpzi9h9" data-mpi={j} />)}
                </div>
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug sm:text-sm" data-id="element-181" data-mp="1ith4fyjj3yqa">
                “{t.quote}”
              </blockquote>
              <p className="mt-auto pt-1.5 font-sub text-sm font-extrabold text-noche" data-id="element-182" data-mp="1xi90z4dcp5aw">
                {t.author}{' '}
                <span className="font-sans text-xs font-semibold text-noche/70" data-id="element-183" data-mp="1sk7hwjfxd5zf">
                  · {t.detail}
                </span>
              </p>
            </Reveal>)}
        </ul>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-184" data-mp="1jhg3qbvnzw43">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
        <p className="mt-2.5 text-xs font-semibold text-white/85" data-id="element-185" data-mp="1ekpsc1ut1op0">
          Acceso Inmediato • Garantía de 7 Días
        </p>
      </div>
    </section>;
}